import { ActivatedRoute } from "@angular/router";

// Routes where the header/footer should be hidden:
// - Shopify embedded flows (oauth, dashboard, payment confirmation, package selection)
// - White-label/partner embeds (Magento2, CCVShop, Orderchamp)
// - Generic external embed paths
const NOT_VISIBLE_EXCEPTIONS = [
  'magento2',
  'ccvshop',
  '/external/',
  '/oauthshopifyrequest/',
  '/shopifycombipackage/',
  '/shopifydashboard/',
  '/shopifypaymentconfirmation/',
  '/oauthresult',
  '/shopifyoauthresult'
];

export const headerFooterVisible = (activatedRoute: ActivatedRoute): boolean =>
    !NOT_VISIBLE_EXCEPTIONS.some(e => activatedRoute.toString().includes(e));
